import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "../../styles/FloatingLabelInput.css";
import { FaTimesCircle } from "react-icons/fa";

const FloatingLabelInput = ({
  label,
  type = "text",
  value,
  onChange,
  clearValue,
  ...rest
}) => {
  const [isFocused, setFocused] = useState(false);

  return (
    <div className="input-wrapper">
      {type === "phone" ? (
        <PhoneInput
          country={"in"}
          value={value}
          onChange={(val) => onChange(`+${val}`)}
          inputClass="form-control" // keep default
          containerClass={`react-tel-input ${isFocused ? "focused" : ""} ${
            value ? "has-value" : ""
          }`}
          buttonClass="!bg-white"
          dropdownClass="!bg-white !text-black !border-gray-300"
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          {...rest}
        />
      ) : (
        <input
          type={type}
          className={`floating-input ${isFocused || value ? "has-text" : ""}`}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          {...rest}
        />
      )}

      {/* Clear Icon */}
      {value && (
        <span className="clear-icon text-black" onClick={clearValue}>
          <FaTimesCircle />
        </span>
      )}

      {/* Floating Label */}
      <label className={`floating-label ${isFocused || value ? "float" : ""}`}>
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
